<template>
  <ContentContainer :loadingStatus="isLoading">
    <div class="hotel-information content-wrapper">
      <div class="page-header">{{ $t('hotelInformation') }}</div>
      <el-container>
        <el-row class="hotel-logo">
          <img v-if="hotel.logoUrl !== ''" width="150px" alt="Contract Manager logo" :src="hotel.logoUrl">
          <img v-if="hotel.logoUrl === ''" width="150px" alt="Contract Manager logo" src="@/assets/logo_placeholder.png">
        </el-row>
        <el-row class="hotel-status">
          <el-tag :type="(hotel.isEnable === 1) ? 'success' : 'danger'">{{ getHotelStatus(hotel.isEnable) }}</el-tag>
        </el-row>
        <el-header>{{ hotel.name }}</el-header>
        <el-main>
          <el-row>
            <div>
              <strong>{{ $t('code') }}:</strong>
            </div>
            <div>
              {{ (hotel.code !== '') ? hotel.code : '-' }}
            </div>
          </el-row>
          <el-row>
            <div>
              <strong>{{ $t('address') }}:</strong>
            </div>
            <div>
              {{ (hotel.address !== '') ? hotel.address : '-' }}
            </div>
          </el-row>
          <el-row>
            <div>
              <strong>{{ $t('email') }}:</strong>
            </div>
            <div v-if="hotel.information.emailList.length > 0">
              <span v-for="(email, index) in hotel.information.emailList" :key="`email-${index}`">
                {{(email !== '') ? email: '-' }}<span v-if="(index < (hotel.information.emailList.length - 1))">, </span>
              </span>
            </div>
            <div v-if="hotel.information.emailList.length < 1">-</div>
          </el-row>
          <el-row>
            <div>
              <strong>{{ $t('tel') }}:</strong>
            </div>
            <div v-if="hotel.information.phoneList.length === 0"> - </div>
            <div v-if="hotel.information.phoneList.length > 0">
              <span v-for="(phone, index) in hotel.information.phoneList" :key="`phone-${index}`">
                {{(phone !== '') ? phone : '-' }}<span v-if="(index < (hotel.information.phoneList.length - 1))">, </span>
              </span>
            </div>
            <div v-if="hotel.information.phoneList.length < 1">-</div>
          </el-row>
          <el-row>
            <div>
              <strong>{{ $t('fax') }}:</strong>
            </div>
            <div v-if="hotel.information.faxList.length === 0"> - </div>
            <div v-if="hotel.information.faxList.length > 0">
              <span v-for="(fax, index) in hotel.information.faxList" :key="`fax-${index}`">
                {{ (fax !== '') ? fax : '-' }}<span v-if="(index < (hotel.information.faxList.length - 1))">, </span>
              </span>
            </div>
            <div v-if="hotel.information.faxList.length < 1">-</div>
          </el-row>
          <el-row class="change-info-button">
            <el-button type="primary" v-on:click="onEditButtonClick()">{{ $t('changeInformation') }}</el-button>
          </el-row>
        </el-main>
      </el-container>
    </div>
  </ContentContainer>
</template>

<script>
import i18nMessages from '@/translations/Hotel/ManageHotel/Information/Index.i18n'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import { getStatusName } from '@/helpers'
import { getHotelInfo, getHotelIndexRoute } from '@/services/hotel-service'
import ContentContainer from '@/components/ContentContainerComponent.vue'
import LocalStorageFactory from '@/factories/local-storage-factory'
import { STATUS } from '@/configs/constant'
import { mapState } from 'vuex'

export default {
  name: 'HotelInfo',
  mixins: [AlertViewMixin],
  components: { ContentContainer },
  i18n: { messages: i18nMessages },
  created: async function () {
    if (this.activeHotelId === undefined || this.activeHotelId === '') {
      const companyDetail = LocalStorageFactory.getCompanyDetail()
      const routeName = await getHotelIndexRoute(companyDetail, this.$store)

      return this.$router.push({
        name: routeName
      })
    }

    try {
      await this.getHotelInfo(this.activeHotelId)
    } catch (err) {
      this.alertError(err.message)
    }
  },
  computed: {
    ...mapState({
      activeHotelId: state => state.general.activeHotelId
    })
  },
  watch: {
    activeHotelId: function (val) {
      this.getHotelInfo(val)
    }
  },
  data () {
    return {
      isLoading: false,
      isEditMode: false,
      hotel: {
        code: '',
        name: '',
        isEnable: STATUS.ENABLE,
        information: {
          address: '',
          emailList: [],
          phoneList: [],
          faxList: []
        },
        logoUrl: ''
      }
    }
  },
  methods: {
    getHotelStatus: function (status) {
      return this.$t(getStatusName(status))
    },
    getHotelInfo: async function (hotelId) {
      this.isLoading = true
      this.isEditMode = false
      try {
        this.hotel = await getHotelInfo(hotelId)
      } catch (err) {
        this.alertError(err.message)
      }
      this.isLoading = false
    },
    onEditButtonClick: function () {
      this.$router.push({
        name: 'EditHotelInfo',
        params: {
          hotel: this.hotel
        }
      })
    }
  }
}
</script>

<style scoped>
  .el-header {
    background-color: #f8f9fa;
    color: #2c3e50;
    text-align: center;
    line-height: 60px;
    font-weight: bold;
  }

  .el-row {
    font-size: 14px;
    padding: 10px 0;
    border-bottom: 1px #dadbdd solid;
  }

  .hotel-status, .change-info-button {
    border: 0;
    text-align: center;
  }

  .hotel-logo {
    border: 0;
    margin: 0 auto 20px;
  }

  .el-container {
    width: 80%;
    margin: 0 auto;
  }
</style>
